// Styles
import './styles.css';

// Core
import React, { Component } from 'react';
import { connect } from 'react-redux';

// Services
import RsvpService from '../../services/RsvpService';
import { updateReduxStore } from '../../services/RefreshData';
import { SelfCheckinRefreshInterval } from '../../services/SelfCheckinRefreshInterval';
import RSVP_CONSTS from '../../constants';
import DateUtils from '../../services/DateUtils';

// Components
import { 
    Footer,
    Header,
    Profile,
} from '../../components';
import Sessions from '../../components/sessions';
import EventDescription from './components/EventDescription';
import OnlineDetails from './components/OnlineDetails';
import Actions from './components/Actions';
import Controls from '../../components/controls/controls.jsx';

export class RsvpPage extends Component {

    rsvpService = new RsvpService();

    init(props) 
    {
        let data = props && props.check ? props.check : [];
        data = this.rsvpService.parseRsvp(data);

        const { event, location, contact, account } = data;

        this.setState({location:location});
        document.title = `${contact.full_name} RSVP${event ? `: ${ event.title}`  : ''} | Gecko`;

        this.renderGeckoChatWidget(event.chat_channel_id, event.chat_widget_id, account, contact);

        // Update redux store
        updateReduxStore(data);

        // Set account timeFormat
        DateUtils.setTimeFormatFromAccount(account.time_format);

        // Set locale for date formating
        DateUtils.setLocale();

        // Init page data refresh (online events ONLY)
        SelfCheckinRefreshInterval(data);
    }

    UNSAFE_componentWillMount() 
    {
        this.init(this.props);
    }

    UNSAFE_componentWillReceiveProps(props) 
    {
        if (JSON.stringify(this.props.check) === JSON.stringify(props.check)) return;

        this.init(props);
    }

    env()
    {
        if (window) {
            // GeckoEngage
            if (window.location.host.indexOf('geckoengage') !== -1) {
                // return 'https://api.geckoengage.com';
                return 'prod';

            // Gecko (stage)
            } else if (window.location.host.indexOf('.com') !== -1 && window.location.host.indexOf('stage') !== -1) {
                // return 'https://api-stage.geckoform.com';
                return 'stage';

            // Gecko (live)
            } else if (window.location.host.indexOf('.com') !== -1) {
                // return 'https://api.geckoform.com';
                return 'prod';

            // Gecko (dev)
            } else {
                return 'local';
                // return 'http://api.geckoform.test:8000';
            }
        }
    }


    renderGeckoChatWidget(channel_id, widget_id, account, contact)
    {
        // Once a bubble has been initialised it cant be changed
        // this bubble will follow the user around the RSVP website
        // until the session storage is cleared
        if (window.GeckoChatSettings) {
            return;
        }

        const env = this.env();
        
        // NEW CHAT
        if (widget_id) {
            const { uuid, short_name } = account;

            const configScript = (() => {
                const script = document.createElement('script');
                script.appendChild(document.createTextNode(`
                    window.GeckoChatSettings = {
                        widgetId:"${uuid}-${widget_id}",
                        accountName:"${short_name}"
                    };
                `));
                return script;
            })();
            
            const embedScript = (() => {
                const script = document.createElement('script');
                script.src = (() => {
                    if (['stage', 'local'].includes(env)) {
                        return `https://chat-widget-stage.geckoengage.com`;
                    }
                    return `https://chat-widget.geckoengage.com`;
                })();
                return script;
            })();

            // Add to <head>
            document.head.appendChild(configScript);
            document.head.appendChild(embedScript);

        // OLD CHAT
        } else if (channel_id) {
            window.GeckoChatSettings = {
                // Note; this is poorly named
                account_id: channel_id,
                auto_boot: true,
            }
            
            if (env === 'stage') {
                window.GeckoChatSettings.api_override = 'https://api-stage.geckochat.io';
                window.GeckoChatSettings.router_override = 'https://router-stage.geckochat.io';
                
            } else if (env === 'local') {
                window.GeckoChatSettings.api_override = 'http://localhost:5000';
                window.GeckoChatSettings.router_override = 'http://localhost:3000';
            }

            if (contact) {
                const name_parts = contact.full_name.split(' ');
                window.GeckoChatSettings.user_info = {
                    first_name: name_parts[0],
                    last_name: name_parts[name_parts.length - 1],
                    email: contact.email,
                    engage_contact_id: contact.id,
                };
            }

            const src_script = document.createElement("script");
            src_script.src = "https://embed.geckochat.io";
            document.head.appendChild(src_script);
        }
    }

    bookedSessions() {
        return this.props.sessions.filter(session => !!session.attendance && session.attendance.status !== 90 && session.attendance.status !== 80);
    }

    renderControls(event)
    {
        if (!event || !event.attendance) {
            return null;
        }

        return this.renderEverythingElse(event);
    }

    renderEverythingElse(event)
    {

        const attendance = event.attendance;

        if (this.isRemovedOrCancelled(attendance.status)) {
            return null;
        }

        const sessions = <Sessions title="Booked Sessions" event={event} sessions={this.bookedSessions()} />;
        const description = <EventDescription description={event.description} hosts={this.props.hosts} />;
        let actions = null;

        let onlineDetails = null;
        if (RsvpService.isOnline(event) && [RSVP_CONSTS.ATTENDANCE.STATUS_ATTENDED, RSVP_CONSTS.ATTENDANCE.STATUS_ENGAGED].indexOf(this.props.eventAttendance.status) !== -1 && !event.video_uuid && (event.webinar_url || event.webinar_description)) {
            onlineDetails = <OnlineDetails url={event.webinar_url} description={event.webinar_description} />;
        }

        if (!this.isInvited(attendance.status) && !RsvpService.hasEventPassed(event)){
            actions = <Actions eventAttendance={this.props.eventAttendance} event={event}/>;
        }

        return (
            <div>
                {onlineDetails}
                {sessions}
                {description}
                {actions}
            </div>
        )
    }
   
    isRemovedOrCancelled(status) {
        return (this.isRemoved(status) || this.isCancelled(status) ? true : false)
    }

    isRemoved(status)
    {
        if (status && status === 80) {
            return true;
        }

        return false;
    }

    isCancelled(status)
    {
        if (status && status === 90) {
            return true;
        }

        return false;
    }
    

    isInvited(status)
    {
        if (status && status === 20) {
            return true;
        }

        return false;
    }

    render() {
        const event = this.props.events && this.props.events.length ? this.props.events.find(e => !e.parent_id) || {} : {};

        return (
            <>
                <Header name={event.title} background={event.image} color={event.color} />
                <main>
                    <div className="rsvp-page-inner-container">
                        <div className="public-form-holder rsvp-page">                 
                            <Profile event={event} location={this.state.location} />
                            <Controls />
                            {this.renderControls(event)}
                        </div>
                    </div>
                </main>
                <Footer />
            </>
        );
    }
}

const mapStateToProps = store => {
    return {
        account: store.account,
        contact: store.contact,
        eventAttendance: store.eventAttendance,
        events: store.events,
        attendances: store.attendances,
        sessions: store.sessions,
        hosts: store.hosts,
    }
}

export default connect(
    mapStateToProps
)(RsvpPage);